<template>
  <div class="app">
    <div style="padding-right:8px;display:flex;position: fixed;z-index: 99;background-color:white;flex-direction: column;"
      v-if="isMobile">
      <div style="display:flex;">
        <div style="display:flex;align-items: center;justify-content: center;">
          <img src="./img/zhanshi.png" alt="logo" class="logo" />
        </div>
        <Header :activeIndex="2" />
      </div>
      <div class="hengtiao">
        <div class="xiangji"><i class="el-icon-camera"></i></div>
        <div class="gerenxinxi">职业测试管理</div>
      </div>
    </div>
    <div class="hengtiao1" v-if="!isMobile">
    </div>
    <div class="hengtiao" v-if="!isMobile">
      <div class="xiangji"><i class="el-icon-camera"></i></div>
      <div class="gerenxinxi">职业测试管理</div>
    </div>
    <div class="head01">
      <Header :activeIndex="2" v-if="!isMobile" />
      <div class="neirong">
        <el-table v-if="!isMobile" :data="currentQuestions" height="750" stripe style="width: 100%;">
          <el-table-column prop="index" label="题号" width="180" />
          <el-table-column prop="question" label="问题" width="700" />
          <el-table-column label="答案" width="280">
            <template #default="scope">
              <el-radio v-model="userAnswers[scope.row.id]" label="1">是</el-radio>
              <el-radio v-model="userAnswers[scope.row.id]" label="2">否</el-radio>
            </template>
          </el-table-column>
        </el-table>

        <el-table v-else :data="currentQuestions" stripe style="width: 100%;">
          <el-table-column prop="index" label="题号" width="50" />
          <el-table-column prop="question" label="问题" width="230" />
          <el-table-column label="答案" width="70">
            <template #default="scope">
              <el-radio v-model="userAnswers[scope.row.id]" label="1">是</el-radio>
              <el-radio v-model="userAnswers[scope.row.id]" label="2">否</el-radio>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin-top: 20px; text-align: center;">
          <el-button @click="goToPreviousPage" :disabled="currentPage === 1" style="margin-right: 10px;">
            上一页
          </el-button>

          <el-button v-if="!isLastPage" @click="goToNextPage" :disabled="!canGoToNextPage" style="margin-left: 10px;">
            下一页
          </el-button>

          <el-button v-if="isLastPage" @click="save" :disabled="!canGoToNextPage" type="primary">提交</el-button>
        </div>
      </div>
    </div>
    <Footer></Footer>
  </div>
</template>
<script>
import Header from './Header.vue';
import Footer from './Footer.vue'
export default {
  name: 'usersystem',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      userId: sessionStorage.getItem("userId"),
      userAnswers: {},
      careerScores: {},
      yuanbendaan: [],
      userAnswerString: '',
      typeScore: '',
      result: '',
      BASE_URL: 'https://zhiyedashi.com/career',
      BASE_URL1: 'https://zhiyedashi.com/info',
      // BASE_URL: 'http://192.168.2.8:8203',
      // BASE_URL1: 'http://192.168.2.8:8206',
      questions: [],
      currentPage: 1,
      questionsPerPage: 14,
      isMobile: false
    }
  },
  created() {
    if (!this.userId) {
      console.warn('关键数据未获取到，停止执行后续逻辑');
      this.$router.push('/')
    }
  },
  computed: {
    currentQuestions() {
      const start = (this.currentPage - 1) * this.questionsPerPage;
      const end = start + this.questionsPerPage;
      return this.questions.slice(start, end);
    },
    canGoToNextPage() {
      return this.currentQuestions.every(
        (question) => this.userAnswers[question.id] !== undefined
      );
    },
    isLastPage() {
      return this.currentPage === Math.ceil(this.questions.length / this.questionsPerPage);
    },
  },
  mounted() {
    this.selectCareertest()
    this.checkMobile();
    window.addEventListener('resize', this.checkMobile);
  },
  methods: {
    checkMobile() {
      this.isMobile = window.innerWidth <= 768;
    },
    goToPreviousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    goToNextPage() {
      if (this.currentPage < Math.ceil(this.questions.length / this.questionsPerPage)) {
        this.currentPage++;
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    save() {
      this.careerScores = {};
      this.yuanbendaan.forEach(item => {
        const { id, careerType, answer } = item;
        const userAnswer = this.userAnswers[id];

        if (userAnswer && parseInt(userAnswer) === answer) {
          if (!this.careerScores[careerType]) {
            this.careerScores[careerType] = 0;
          }
          this.careerScores[careerType] += 1;
        }
      });

      this.typeScore = Object.entries(this.careerScores)
        .map(([key, value]) => `${key}:${value}`)
        .join(';');

      this.userAnswerString = Object.entries(this.userAnswers)
        .map(([key, value]) => `${key}:${value}`)
        .join(';');

      const sortedScores = Object.entries(this.careerScores)
        .sort((a, b) => b[1] - a[1])
        .slice(0, 3);

      this.result = sortedScores.map(item => item[0]).join('');
      let careerResult = {
        userId: this.userId,
        userAnswer: this.userAnswerString,
        typeScore: this.typeScore,
        result: this.result
      }
      fetch(`${this.BASE_URL}/admin/career/result/saveResult`, {
        method: 'post',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(careerResult)
      })
        .then(res => res.json())
        .then(data => {
          // console.log("保存成功", data);
          if (data.code === 200 && data.data === '数据保存成功') {
            sessionStorage.setItem("zhiyeceshi", "true")
            fetch(`${this.BASE_URL1}/admin/resumes/selectResumes`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
              },
              body: `userId=${this.userId}`
            })
              .then(res => res.json())
              .then(data => {
                if (data.data === '暂无学业信息') {
                  this.$router.push('/personalInf');
                } else {
                  this.$router.push('/researchrep');
                }
              })
              .catch(error => {
                console.error("查询失败，原因是", error);
              });
          } else {
            alert("网络有波动，请稍后重试~")
          }
        })
        .catch(error => {
          console.error("保存失败，原因是", error);
        })
    },
    selectCareertest() {
      fetch(`${this.BASE_URL}/admin/career/random`, {
        method: 'POST'
      })
        .then(res => res.json())
        .then(data => {
          this.questions = data.data.map((item, index) => ({
            ...item,
            index: index + 1,
          }));
          this.yuanbendaan = data.data.map((item) => ({
            id: item.id,
            careerType: item.careerType,
            answer: item.answer
          }))
        })
        .catch(error => {
          console.error("查询失败，原因是", error);
        });
    }
  }
}
</script>
<style scoped>
.mobile-list {
  padding: 10px;
}

.mobile-card {
  background: white;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.card-header {
  margin-bottom: 10px;
}

.question-index {
  font-weight: bold;
  color: #409EFF;
}

.question-text {
  margin-bottom: 15px;
  line-height: 1.5;
}

.answer-options {
  display: flex;
  gap: 20px;
}

.hengtiao1 {
  height: 8px;
  width: 100%;
  background-color: white;
  display: flex;
  align-items: center;
}

.hengtiao {
  height: 50px;
  width: 100%;
  background-color: #3572e5;
  color: white;
  display: flex;
  align-items: center;
}

.xiangji {
  margin-left: 20px;
  font-weight: 800;
  font-size: 28px;
}

.gerenxinxi {
  margin-left: 20px;
  font-weight: 700;
}

.head01 {
  display: flex;
  height: 87vh;
  width: 100%;
}

.neirong {
  display: flex;
  justify-content: center;
  gap: 30px;
  margin-top: 30px;
  margin-left: 80px;
  flex-direction: column;
  width: 100%;
}

@media (max-width: 768px) {
  .hengtiao {
    height: 50px;
    width: 100%;
    background-color: #3572e5;
    color: white;
    display: flex;
    align-items: center;
  }

  .el-table {
    width: 100%;
    display: block;
  }

  .el-table-column {
    display: block;
    width: 100%;
    padding: 10px 0;
    border-bottom: 1px solid #ddd;
  }

  .el-table-column .cell {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .el-radio-group {
    display: flex;
    flex-direction: column;
  }

  .el-radio {
    margin-bottom: 5px;
  }

  .head01 {
    height: auto;
    gap: 10px;
    padding-top: 140px;
  }

  .neirong {
    margin-left: 0;
    margin-top: 10px;
    width: 100%;
    gap: 20px;
  }

  .logo {
    width: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CareerQuiz.vue